import React from 'react';
import { Portal, Tooltip } from '@mui/material';
import { IconButton } from '@ui/buttons';
import { useProjectsForOverview } from '@client/store/project';
import { shouldShowProjectListChrome } from './helpers/project-list-chrome.helpers';
import { useProjectListView } from './project-list-view.context';

export const ProjectListViewTabs = () => {
  const { view, setView } = useProjectListView();
  const projects = useProjectsForOverview();
  const showChrome = shouldShowProjectListChrome(projects.length);
  const targetView = view === 'Map' ? 'List' : 'Map';
  const label = targetView === 'List' ? 'List view' : 'Show map';
  if (!showChrome) return null;
  return (
    <Portal container={() => document.getElementById('project-list-view-tabs')}>
      <Tooltip title={label}>
        <IconButton
          category="ui"
          icon={targetView === 'List' ? 'projectListView' : 'projectMapView'}
          size={18}
          aria-label={label}
          onClick={() => setView(targetView)}
          sx={{
            color: 'rgba(0,0,0,0.3)',
            visibility: 'inherit',
            opacity: 1,
            transitionProperty:
              'background-color, color, box-shadow, opacity, visibility',
            transitionDuration: '200ms',
          }}
        />
      </Tooltip>
    </Portal>
  );
};
